import { STATS } from "../constants";
import { instance } from "../../axios";

let getStatsDashboardAction = () => {
  return (dispatch) => {
    dispatch({
      type: STATS.GET_STATS_DASHBOARD,
    });
    instance
      .get("/stats/dashboard")
      .then((results) => {
        dispatch({
          type: STATS.GET_STATS_DASHBOARD_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: STATS.GET_STATS_DASHBOARD_FAILURE,
          payload: error,
        });
      });
  };
};

let cleanStatsAction = () => {
  return (dispatch) => {
    dispatch({
      type: STATS.CLEAN_STATS,
    });
  };
};

export { getStatsDashboardAction, cleanStatsAction };
